/* Source: src/mt-includes/js/src/rendering/init.js*/
angular.module('website.backend.RenderService', ['core.library.jsonrpc']);